import { AfterViewInit, Component, OnInit, Renderer2, QueryList, ViewChild, ViewChildren, ViewEncapsulation, OnDestroy, PipeTransform } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { buttonTypes, componentName, ComponentTypes, LocationFilter, DefaultReservationView } from 'src/app/shared/constants/commonenums';
import { DynamicFormComponent } from 'src/app/shared/dynamicform/dynamic-form/dynamic-form.component';
import { ButtonValue, FieldConfig } from 'src/app/shared/dynamicform/models/common-models';
import { CoverTypePriceDTO, MealTabDTO, operationType, SpecialMealDTO } from 'src/app/shared/Models/WidgetSettingsModels';
import { Utilities } from 'src/app/shared/utilities/utilities';
import { LayoutService } from '../../layout.service';
import { ReservationService } from '../../reservation.service';
import _ from 'lodash';
import { Pipe } from '@angular/core';
import { ElementRef } from '@angular/core';
import { PartyPrepaymentState, PartyState } from 'src/app/shared/Models/PartyModels';
import { DynamicFormService } from 'src/app/shared/dynamicform/service/dynamic-form.service';
import { PopupMessageComponent } from 'src/app/shared/components/popup-message/popup-message.component';
import { ComponentDetails } from 'src/app/shared/dynamicform/models/popup.interface';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PopupService } from 'src/app/shared/services/popup.service';
import { TableLockedDTO } from 'src/app/shared/Models/SlotLockModels';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { GuestService } from 'src/app/shared/services/guest.service';

@Component({
  selector: 'app-reservation-details',
  templateUrl: './reservation-details.component.html',
  styleUrls: ['./reservation-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReservationDetailsComponent extends Utilities implements OnInit, AfterViewInit, OnDestroy {
  previousButton: ButtonValue;
  nextButton: ButtonValue;
  CheckAvailabilityBtn: ButtonValue;
  reservationConfig: FieldConfig[];
  coverTypeConfig: FieldConfig[] = [];
  timeBtnArrayConfig: FieldConfig[] = [];
  reservationSelectionConfig: FieldConfig[] = [];
  reservationDetailsFormGp: FormGroup;
  @ViewChild('availableDateContainer') el: ElementRef;
  subscriptions: Subscription = new Subscription();
  @ViewChild('reservationConfigForm', { static: true }) reservationConfigForm: DynamicFormComponent;
  @ViewChild('timeConfigForm', { static: true }) timeConfigForm: DynamicFormComponent;
  @ViewChild('reservationSelectionForm', { static: true }) reservationSelectionForm: DynamicFormComponent;
  @ViewChild('coverTypeForm', { static: true }) coverTypeForm: DynamicFormComponent;
  @ViewChildren('form') components: QueryList<DynamicFormComponent>;
  @ViewChildren('popContent') popover: QueryList<NgbPopover>;
  buttonType = buttonTypes;
  selectedMeal: SpecialMealDTO;
  specialMealList: SpecialMealDTO[] = [];
  seatingAreaMasterList = [];
  seatingTypesMasterList = [];
  seatingAreaData = [{ id: 1, value: 'Main Dining' }, { id: 2, value: 'Family Pool' }];
  seatingTypeData = [{ id: 1, value: 'VIP' }, { id: 2, value: 'Balcony' }]
  SeatingAreaSeatingTypeMappings = [];
  partySizeOptions = [];
  showSlots: boolean = false;
  restaurantId: Number;
  isDropdown = false;
  availableCoverTypePrices: CoverTypePriceDTO[] = [];
  availableMealPeriods: any = [];
  timeBtnArray = [];
  daysForReservation: number;
  selectedPartySize: number;
  operationType = operationType;
  showOtherDays = false;
  selectedDay: any;
  dateSelectedInOtherDaysAvailability: any;
  otherAvailableDays = [];
  seatingTypeInfoPopup: MatDialogRef<any>;
  tableLockDTO: TableLockedDTO;
  showRefreshText = false;
  isSpecialMealDisabled = false;
  displaySeatingType = true;
  displaySeatingArea = true;
  availabilityText: any = '';
  triggerAvailableDatesApiCall = false;
  PartyPrepaymentState = PartyPrepaymentState;
  selectedMealTab: number = 0;
  originalReservedFor: Date;
  partySizeError: string;
  isSpecialMealAvailable = true;
  isInitialEdit = true;
  isNextBtnDisabled = false;
  openHourDays = [];
  CustomOpenHours = [];

  public config: SwiperConfigInterface = {
    slidesPerView: 3,
    spaceBetween: 10,
    slideToClickedSlide: false,
    breakpoints: {
      650: {
        slidesPerView: 3
      },
      800: {
        slidesPerView: 4,
      },
      1024: {
        slidesPerView: 5,
      },
      1366: {
        slidesPerView: 7,
      },
      1500: {
        slidesPerView: 8,
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  };

  constructor(private ts: TranslateService, private dfs: DynamicFormService, public ls: LayoutService, private fb: FormBuilder, private rs: ReservationService, private renderer: Renderer2, public dialog: MatDialog, private ps: PopupService, public gs: GuestService) {
    super(dialog);
  }

  ngOnInit(): void {
    this.reservationDetailsFormGp = this.fb.group({
      specialMeal: [''],
      partySize: '',
      reservationDate: new Date(),
      seatingArea: '',
      seatingType: '',
      reservationTime: ['', Validators.required],
      communalAvailability: false,
      tableId: [''],
      coverTypes: [],
      eventSelection: ''
    });
    this.rs.reservationFormGroup.addControl('reservationDetailsForm', this.reservationDetailsFormGp);
    this.displaySeatingArea = this.ls.restaurantWidgetSettings$.value.WidgetCustomization?.LocationFilters?.filter(x => x == LocationFilter.ByArea).length > 0;
    this.displaySeatingType = this.ls.restaurantWidgetSettings$.value.WidgetCustomization?.LocationFilters?.filter(x => x == LocationFilter.ByType).length > 0;
    this.createReservationConfig();
    if (!this.ls.restaurantWidgetSettings$.value.WidgetCustomization.AllowNewReservations) {
      let eventOptions = [{
        id: 0,
        value: 'specialEvent'
      }, { id: 1, value: 'dailyReservation' }];
      this.reservationSelectionConfig = [
        {
          type: 'radio',
          name: 'eventSelection',
          placeholder: '',
          options: eventOptions,
          isFormArray: false,
          class: "reservation-details__events",
          value: this.ls.editPartyData?.eventSelection ? this.ls.editPartyData.eventSelection : this.ls.restaurantWidgetSettings$.value.WidgetCustomization.DefaultReservationView ? this.ls.restaurantWidgetSettings$.value.WidgetCustomization.DefaultReservationView : eventOptions[0].id,
          cellClick: this.EventSelection.bind(this),
          disabled: false,
          selectValue: true
        }
      ]
    this.dfs.selectedRadioOption = this.ls.editPartyData?.eventSelection ? this.ls.editPartyData.eventSelection : this.ls.restaurantWidgetSettings$.value.WidgetCustomization.DefaultReservationView ? this.ls.restaurantWidgetSettings$.value.WidgetCustomization.DefaultReservationView : eventOptions[0].id;
    }
    if(this.ls.restaurantWidgetSettings$.value.WidgetCustomization.DefaultReservationView) {
      this.isSpecialMealAvailable = false;
    }
    this.createActionButtons();
    this.rs.additionalGuestPage = false;

  }

  EventSelection(event) {
    this.reservationSelectionConfig[0].value = event.value;
    this.reservationSelectionConfig = [...this.reservationSelectionConfig];
    this.rs.reservationFormGroup.get('reservationDetailsForm').get('eventSelection').setValue(event.value);
    if (event.value) {
      this.isSpecialMealAvailable = false;
      this.reservationDetailsFormGp.controls.specialMeal.setValue('');
      this.selectedSpecialMeal('');
    } else {
      this.isSpecialMealAvailable = true;
      this.selectedSpecialMeal(this.specialMealList[0]);
    }
  }
  createReservationConfig() {
    this.reservationConfig = [
      {
        type: 'select',
        name: 'partySize',
        placeholder: '',
        options: [],
        appearance: true,
        isFormArray: false,
        label: 'partySize',
        class: "reservation-details__party-size",
        validation: [Validators.required],
      },
      {
        type: 'date',
        name: 'reservationDate',
        placeholder: '',
        appearance: true,
        isFormArray: false,
        label: 'date',
        class: "reservation-details__date",
        validation: [Validators.required],
        disabled: false,
      },
      {
        type: 'select',
        name: 'seatingArea',
        placeholder: '',
        options: this.seatingAreaData,
        appearance: true,
        isFormArray: false,
        label: 'seatingArea',
        class: this.displaySeatingArea ? "reservation-details__seating-area" : "reservation-details__seating-area-hide",
        value: 0,
        validation: [Validators.required],
        isNativeControl: this.ls.isMobileBrowser

      },
      {
        type: 'select',
        name: 'seatingType',
        placeholder: '',
        options: this.seatingTypeData,
        appearance: true,
        isFormArray: false,
        label: 'seatingType',
        class: this.displaySeatingType ? "reservation-details__seating-type" : "reservation-details__seating-type-hide",
        value: 0,
        validation: [Validators.required],
        isNativeControl: this.ls.isMobileBrowser
      },
      {
        type: 'checkbox',
        placeholder: 'communalTableAvailability',
        value: false,
        name: 'communalAvailability',
        class: 'reservation-details__communal-availability',
        isFormArray: false,
      }
    ];
  }


  createActionButtons() {
    this.nextButton = {
      type: buttonTypes.confirmBtn,
      label: 'next',
      customclass: 'reservation-details__confirm-btn',
    };
    this.previousButton = {
      type: buttonTypes.cancelBtn,
      label: 'previous',
      customclass: 'reservation-details__previous-btn',
      disbaledproperity: true
    };
    this.CheckAvailabilityBtn = {
      type: buttonTypes.confirmBtn,
      label: 'checkAvailability',
      customclass: 'reservation-details__availablity-btn',
      disbaledproperity: false
    };

    this.subscriptions.add(this.ps.actionEnabled$.subscribe(from => {
      if (from == ComponentTypes.seatingTypeInfoPopup) {
        this.seatingTypeInfoPopup.close();
        this.updateLockedTableInReservationForm(this.tableLockDTO);
        this.ls.nextButton.next(componentName.guestDetails);
      }
    }));

    this.subscriptions.add(this.ps.cancelEnabled$.subscribe(from => {
      if (from == ComponentTypes.seatingTypeInfoPopup) {
        this.seatingTypeInfoPopup.close();
        if (this.ls.lockResult && this.ls.lockResult.SlotLockIdDTO) {
          this.rs.ReleaseLockSlot(this.ls.restaurantWidgetSettings$.value.RestaurantId, this.ls.lockResult.SlotLockIdDTO.Id).subscribe(data => {
            this.ls.offTimer();
          });
        }
      }
    }));
  }

  ngAfterViewInit() {
    this.availabilityText = this.ts.instant('showAvailableDays');
    this.setResetBackgroundColor();
    this.subscriptions.add(this.ls.restaurantWidgetSettings$.subscribe(data => {
      if (data) {
        this.loadInitialSettings(data);
        if (!this.ls.editPartyData && this.ls.operation != operationType.edit) {
          let splMealFromURL: any;
          if (this.ls.specialMealIdFromURL && this.specialMealList && this.specialMealList.length > 0) {
            splMealFromURL = this.specialMealList.find(spm => spm.Id == this.ls.specialMealIdFromURL);
          }
          if (splMealFromURL) {
            this.reservationDetailsFormGp.controls.specialMeal.setValue(splMealFromURL);
            this.selectedSpecialMeal(splMealFromURL);
          }
          else {
            let specialMeal = this.ls.restaurantWidgetSettings$.value.WidgetCustomization.DefaultReservationView ? '' : this.specialMealList[0];
            this.reservationDetailsFormGp.controls.specialMeal.setValue(specialMeal);
            this.selectedSpecialMeal(specialMeal);
          }
        }
      }

    }));
    this.subscriptions.add(this.reservationConfigForm.form.valueChanges.subscribe(value => {
      this.selectedDay = ''; // reset the date selected in Other Availability Days
      this.dateSelectedInOtherDaysAvailability = '';      

      this.clearMealTabSelection();

      this.reservationDetailsFormGp.controls.reservationDate.setValue(value.reservationDate)
      this.reservationDetailsFormGp.controls.seatingArea.setValue({ id: value.seatingArea, name: this.seatingAreaMasterList.filter(x => x.Id == value.seatingArea)[0].Name });
      this.reservationDetailsFormGp.controls.seatingType.setValue({ id: value.seatingType, name: this.seatingTypesMasterList.filter(x => x.Id == value.seatingType)[0].Description });
      this.reservationDetailsFormGp.controls.partySize.setValue(value.partySize);
      this.reservationDetailsFormGp.controls.reservationTime.setValue(value.reservationTime);
      this.reservationDetailsFormGp.controls.communalAvailability.setValue(value.communalAvailability);

      this.showSlots = false;
      this.rs.reservationFormGroup.get('reservationDetailsForm').get('reservationDate').setValue(value.reservationDate);
      this.rs.reservationFormGroup.get('reservationDetailsForm').get('seatingArea').setValue({ id: value.seatingArea, name: this.seatingAreaMasterList.filter(x => x.Id == value.seatingArea)[0].Name });
      this.rs.reservationFormGroup.get('reservationDetailsForm').get('seatingType').setValue({ id: value.seatingType, name: this.seatingTypesMasterList.filter(x => x.Id == value.seatingType)[0].Description });
      this.rs.reservationFormGroup.get('reservationDetailsForm').get('partySize').setValue(value.partySize);
      this.rs.reservationFormGroup.get('reservationDetailsForm').get('reservationTime').setValue(value.reservationTime);
      this.rs.reservationFormGroup.get('reservationDetailsForm').get('communalAvailability').setValue(value.communalAvailability);
      this.checkPartySizeValidationAndAssignFormValue();
    }));

    this.subscriptions.add(this.reservationConfigForm.form.controls.seatingArea.valueChanges.subscribe(value => {
      if (value || value == 0) {
        this.LoadSeatingTypes(value);
        if (this.ls.operation == operationType.edit && this.ls.editPartyData$.value && this.triggerAvailableDatesApiCall && !this.CheckAvailabilityBtn.disbaledproperity) {
          this.getRestaurantAvailableDates(this.rs.reservationFormGroup.controls.reservationDetailsForm.value.partySize,
            moment(this.rs.reservationFormGroup.controls.reservationDetailsForm.value.reservationDate).format('YYYY-MM-DD'),
            value,
            this.rs.reservationFormGroup.controls.reservationDetailsForm.value.specialMeal.Id,
            this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id);
        }
      }
    }));
    this.subscriptions.add(this.reservationConfigForm.form.controls.seatingType.valueChanges.subscribe(value => {
      if (value || value == 0) {
        if (this.ls.operation == operationType.edit && this.ls.editPartyData$.value && this.triggerAvailableDatesApiCall && !this.CheckAvailabilityBtn.disbaledproperity) {
          this.getRestaurantAvailableDates(this.rs.reservationFormGroup.controls.reservationDetailsForm.value.partySize,
            moment(this.rs.reservationFormGroup.controls.reservationDetailsForm.value.reservationDate).format('YYYY-MM-DD'),
            this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id,
            this.rs.reservationFormGroup.controls.reservationDetailsForm.value.specialMeal.Id,
            value);
        }
      }
    }));
    this.subscriptions.add(this.reservationConfigForm.form.controls.partySize.valueChanges.subscribe(value => {
      if (value) {
        if (this.ls.operation == operationType.edit && this.ls.editPartyData$.value && this.triggerAvailableDatesApiCall && !this.CheckAvailabilityBtn.disbaledproperity && !(this.coverTypeConfig.length > 0)) {
          this.getRestaurantAvailableDates(value,
            moment(this.rs.reservationFormGroup.controls.reservationDetailsForm.value.reservationDate).format('YYYY-MM-DD'),
            this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id,
            this.rs.reservationFormGroup.controls.reservationDetailsForm.value.specialMeal.Id,
            this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id);
        }
      }
    }));

    this.subscriptions.add(this.reservationConfigForm.form.controls.reservationDate.valueChanges.subscribe(value => {
      if (value) {
        if (this.showSlots && this.availableMealPeriods.length == 0) { //  Reset the Show other days availability
          this.resetOtherDaysAvailability();
        }
      }      
    }));
    this.subscriptions.add(this.coverTypeForm.form.valueChanges.subscribe(val => {
      if (this.coverTypeConfig.length) {
        let partySize = 0;
        this.availableCoverTypePrices.forEach(x => {
          if (this.coverTypeForm.form.controls[x.Id.toString()])
            partySize += +this.coverTypeForm.form.controls[x.Id.toString()].value
        });
        this.reservationConfigForm.form.controls.partySize.setValue(partySize, { emitEvent: false });
        this.reservationDetailsFormGp.controls.partySize.setValue(partySize, { emitEvent: false });
        this.rs.reservationFormGroup.get('reservationDetailsForm').get('partySize').setValue(partySize);
        let specialMealPartySize = this.reservationDetailsFormGp.get('specialMeal').value;
        this.isNextBtnDisabled = (+partySize < specialMealPartySize.MinPartySize) || (+partySize > specialMealPartySize.MaxPartySize);
        this.CheckAvailabilityBtn.disbaledproperity = this.isNextBtnDisabled;
        this.nextButton.disbaledproperity = this.isNextBtnDisabled;
        this.showSlots = false;
        this.checkPartySizeValidationAndAssignFormValue();
        if (+partySize < specialMealPartySize.MinPartySize) {
          this.ts.get('minPartySizeError', {minPartySize: specialMealPartySize.MinPartySize,}).subscribe(result => {
            this.partySizeError = result;
          });
        } else if (+partySize > specialMealPartySize.MaxPartySize) {
          this.ts.get('maxPartySizeError', {maxPartySize: specialMealPartySize.MaxPartySize}).subscribe(result => {
            this.partySizeError = result;
          });
        } else {
          this.partySizeError = '';
        }
      }
    }))
    this.subscriptions.add(
      this.reservationDetailsFormGp.valueChanges.subscribe(x => {
        this.nextButton.disbaledproperity = this.reservationDetailsFormGp.invalid || this.isNextBtnDisabled;
      })
    )

    this.setEditData();

  }

  loadInitialSettings(data) {
    this.daysForReservation = Number(data.DaysForReservation);
    if (this.ls.restaurantWidgetSettings$.value.WidgetCustomization.PartySizeAndDateDisclaimer) {
      this.reservationConfig[0].icon = 'icon-Info';
      this.reservationConfig[0].toolTip = this.ls.restaurantWidgetSettings$.value.WidgetCustomization.PartySizeAndDateDisclaimer;
    }
    this.restaurantId = data.RestaurantId;
    if (!this.ls.restaurantWidgetSettings$.value.WidgetCustomization.ShowCommunalTableAvailabilityOption) {
      let index = this.reservationConfig.findIndex(x => x.name == 'communalAvailability');
      this.reservationConfig.splice(index, 1);
    }
    this.openHourDays = (data.OpenHourDays && data.OpenHourDays.length > 0) ? data.OpenHourDays : [];
    this.CustomOpenHours = (data.CustomOpenHours && data.CustomOpenHours.length > 0) ? data.CustomOpenHours : [];
    this.specialMealList = (data.AvailableSpecialMeals && data.AvailableSpecialMeals.length > 0) ? _.sortBy(data.AvailableSpecialMeals, "SortOrder") : [];
    if (this.specialMealList.length > 0 && this.ls.globalSeatingAreaId) {
      this.specialMealList = this.specialMealList.filter(x => x.SeatingAreaId == this.ls.globalSeatingAreaId);
    }
    this.seatingAreaMasterList = this.ls.globalSeatingAreaId ? data.SeatingAreaList.filter(x => x.Id == this.ls.globalSeatingAreaId) : data.SeatingAreaList;
    this.seatingTypesMasterList = (data.SeatingTypeList && data.SeatingTypeList.length > 0) ? data.SeatingTypeList : [];
    this.addAnySeatingOptionInMasterList();
    this.SeatingAreaSeatingTypeMappings = (data.SeatingAreaSeatingTypeMappings && data.SeatingAreaSeatingTypeMappings.length > 0) ? this.ls.globalSeatingAreaId ? data.SeatingAreaSeatingTypeMappings.filter(x => x.SeatingAreaId == this.ls.globalSeatingAreaId) : data.SeatingAreaSeatingTypeMappings : [];
    if (!this.openHourDays?.length && !this.CustomOpenHours?.length) {
      let dateIndex = this.reservationConfig?.findIndex(x => x.name === 'reservationDate');
      this.reservationConfig[dateIndex].disabled = true;
    }
    this.setAvailableMealPeriod(data.MealTabs);
  }

  setEditData() {
    if (this.ls.editPartyData) { //Onscreen Edit
      this.triggerAvailableDatesApiCall = false;

      // this.selectedSpecialMeal(this.ls.editPartyData.specialMeal);

      if (this.ls.editPartyData.eventSelection) {
        this.isSpecialMealAvailable = false;
        this.reservationDetailsFormGp.controls.specialMeal.setValue('');
        this.selectedSpecialMeal('');
      } else {
        this.isSpecialMealAvailable = true;
        this.selectedSpecialMeal(this.ls.editPartyData.specialMeal);
      }
      this.reservationConfigForm.form.controls.partySize.setValue(this.ls.editPartyData.partySize);
      this.reservationConfigForm.form.controls.reservationDate.setValue(this.ls.editPartyData.reservationDate);
      this.reservationConfigForm.form.controls.seatingArea.setValue(this.ls.editPartyData.seatingArea.id);
      this.LoadSeatingTypes(this.ls.editPartyData.seatingArea.id);
      let selectedSeatingTypeId = this.reservationConfig[3].options.filter(x => x.id == this.ls.editPartyData.seatingType.id)[0];
      this.reservationConfigForm.form.controls.seatingType.setValue(selectedSeatingTypeId ? this.ls.editPartyData.seatingType.id : this.reservationConfig[3].options[0].id);
      this.showSlots = false;
      this.reservationDetailsFormGp.markAsDirty();
      if (this.ls.editPartyData.coverTypes) {
        this.coverTypeConfig.forEach(coverType => {
          coverType.value = this.ls.editPartyData.coverTypes[coverType.name];
        });
      }
      if (this.ls.restaurantWidgetSettings$.value.WidgetCustomization.ShowCommunalTableAvailabilityOption) {
        this.reservationConfigForm.form.controls.communalAvailability.setValue(this.ls.editPartyData.communalAvailability);
      }
      if (this.ls.editPartyData.tableId) { // based on availability again table has to be selected again
        this.ls.editPartyData.tableId = [];
        this.rs.reservationFormGroup.controls.reservationDetailsForm.value.tableId = [];
      }
      if (this.ls.operation == operationType.edit && this.ls.editPartyData$.value) {
        this.originalReservedFor = this.ls.editPartyData$.value.ReservedFor;
        this.getRestaurantAvailableDates(this.rs.reservationFormGroup.controls.reservationDetailsForm.value.partySize,
          moment(this.rs.reservationFormGroup.controls.reservationDetailsForm.value.reservationDate).format('YYYY-MM-DD'),
          this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id,
          this.rs.reservationFormGroup.controls.reservationDetailsForm.value.specialMeal.Id,
          this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id)
      }

    }
    else if (this.ls.operation == operationType.edit && this.ls.editPartyData$.value && this.ls.editPartyData$.value.State !== PartyState.Cancelled) { //Edit Reservation
      this.triggerAvailableDatesApiCall = false;
      this.rs.primaryContact = _.cloneDeep(this.ls.editPartyData$.value.Contact);
      this.rs.secondaryContactList = this.ls.editPartyData$.value.BookingContacts && this.ls.editPartyData$.value.BookingContacts.length > 0 ? _.cloneDeep(this.ls.editPartyData$.value.BookingContacts.filter(bc=>bc.ContactId != this.ls.editPartyData$.value.Contact.Id)) : null;
      this.originalReservedFor = this.ls.editPartyData$.value.ReservedFor;
      this.subscriptions.add(this.ls.editPartyData$.subscribe(data => {
        if (data) {
          let selectedMeal: any = '';
          if (data.SpecialMeal && data.SpecialMeal.Id && !this.specialMealList.find(x => x.Id == data.SpecialMeal.Id)) {
            //Special Meal Deleted
            return;
          }

          selectedMeal = data.SpecialMeal && data.SpecialMeal.Id ? this.specialMealList.filter(x => x.Id == data.SpecialMeal.Id)[0] : '';
          this.selectedSpecialMeal(selectedMeal);
          this.reservationConfigForm.form.controls.partySize.setValue(data.Size);
          this.reservationConfigForm.form.controls.reservationDate.setValue(moment(data.ReservationDate).format('YYYY-MM-DD'));
          this.reservationConfigForm.form.controls.seatingArea.setValue(data.SeatingAreaId > 0 ? data.SeatingAreaId : 0);
          this.LoadSeatingTypes(data.SeatingAreaId > 0 ? data.SeatingAreaId : 0);
          setTimeout(() => {
            this.reservationConfigForm.form.controls.seatingType.setValue(this.displaySeatingType ? (data.SeatingTypeId > 0 ? data.SeatingTypeId : 0) : 0);
          }, 100)

          this.showSlots = false;
          if (this.ls.restaurantWidgetSettings$.value.WidgetCustomization.ShowCommunalTableAvailabilityOption) {
            this.reservationConfigForm.form.controls.communalAvailability.setValue(this.ls.editPartyData$.value.IsCommunalTable);
          }
          this.reservationDetailsFormGp.markAsDirty();

          if (this.ls.editPartyData$.value.CoverTypeQuantities && this.ls.editPartyData$.value.CoverTypeQuantities.length > 0) {
            let totalCovers = 0
            this.coverTypeConfig.forEach(coverType => {
              let coverTypeValue = this.ls.editPartyData$.value.CoverTypeQuantities.filter(x => x.CoverTypeId.toString() == coverType.name)[0];
              if (coverTypeValue) {
                coverType.value = coverTypeValue.Covers;
                totalCovers = totalCovers + coverTypeValue.Covers;
              }
            });
            if (totalCovers == data.Size) { //CoverType was deleted
              this.getRestaurantAvailableDates(data.Size, moment(data.ReservationDate).format('YYYY-MM-DD'), data.SeatingAreaId, data.SpecialMealId, data.SeatingTypeId);
            }
            else {
              this.restrictAvailabilityCheck(true);
            }
          }
          else {
            this.getRestaurantAvailableDates(data.Size, moment(data.ReservationDate).format('YYYY-MM-DD'), data.SeatingAreaId, data.SpecialMealId, data.SeatingTypeId);
          }
        }
      }));
    }
    else if (this.ls.operation == operationType.cancel || (this.ls.editPartyData$.value && this.ls.editPartyData$.value.State === PartyState.Cancelled)) {
      this.ls.nextButton.next(componentName.confirmDetails);
    }

  }

  navigateLeft() {
    let element = this.el.nativeElement;
    if (element.offsetWidth < element.scrollWidth) {
      element.scrollLeft = element.scrollLeft - 60;
    }
  }

  navigateRight() {
    let element = this.el.nativeElement;
    if (element.offsetWidth < element.scrollWidth) {
      element.scrollLeft = element.scrollLeft + 60;
    }
  }

  selectedDate(day) {
    if (!this.CheckAvailabilityBtn.disbaledproperity) {
      this.clearBackgroundColor();
      this.selectedDay = day;
      this.dateSelectedInOtherDaysAvailability = moment(this.selectedDay.value).format('YYYY-MM-DD');
      this.reservationDetailsFormGp.controls.reservationTime.setValue(null);
      this.reservationConfigForm.form?.controls['reservationDate']?.setValue(day.value);
      // this.reservationConfigForm.form?.updateValueAndValidity()
      this.getRestaurantDateAvailability(this.dateSelectedInOtherDaysAvailability);
    }
  }

  clearBackgroundColor() {
    let availabilityDays = document.querySelectorAll('.reservation-details__date-view');
    availabilityDays.forEach(data => {
      this.renderer.removeStyle(data, 'background');
      this.renderer.removeStyle(data, 'color');
    });
  }

  setResetBackgroundColor() {
    this.clearBackgroundColor();
    let selectedAvailabilityDays = document.querySelectorAll('.reservation-details__date-view.reservation-details__selected');
    selectedAvailabilityDays.forEach(data => {
      this.renderer.setStyle(data, 'background', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.AvailableButtonBackgroundColor);
      this.renderer.setStyle(data, 'color', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.AvailableButtonColor)
      //Needed
      //  this.renderer.setStyle(data, 'color', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.EarlierLaterHoverBackgroundColor);
    });
    let coverTypeElements = document.querySelectorAll('.reservation-details__cover-type');
    let coverLength = coverTypeElements.length;
    coverTypeElements.forEach((data, index) => {
      let coverWidth = `calc(100% / ${coverLength})`;
      this.renderer.setStyle(data, 'width', coverWidth);

    });
    setTimeout(() => {
      if (this.ls.editPartyData && this.isInitialEdit && this.ls.isMobileBrowser) {
        this.isInitialEdit = false;
        this.reservationConfigForm.form.controls.partySize.setValue(this.ls.editPartyData.partySize);
      }
    }, 100)
  }

  showOtherDaysAvailable() {
    this.showOtherDays = true;
    this.showRefreshText = true
    this.availabilityText = 'refresh';
    this.otherAvailableDays = [];
    let Date = moment(this.rs.reservationFormGroup.controls.reservationDetailsForm.value.reservationDate).format('YYYY-MM-DD');
    for (let i = 1; i <= this.ls.restaurantWidgetSettings$.value.MaxAlternateDays; i++) {
      let date = this.addDays(this.rs.reservationFormGroup.controls.reservationDetailsForm.value.reservationDate, i - 1);
      if (date) {
        this.otherAvailableDays.push({ Id: i, value: date.toISOString() })
      }
    }
    let mealPeriodConfig = this.reservationConfig.filter(x => x.name === 'mealPeriod');
    if (mealPeriodConfig.length > 0) {
      if (!(mealPeriodConfig[0].class.includes('-hide'))) {
        mealPeriodConfig[0].class = 'reservation-details__meal-period-hide';
      }
    }
  }
  addDays(date, days) {
    var result = new Date(date);
    var maxAllowedDate = this.reservationConfig[1].maxDate;
    result.setDate(result.getDate() + days);
    var daysDiff = moment(moment(result).format('YYYY-MM-DD')).diff(moment(maxAllowedDate).format('YYYY-MM-DD'), 'days')
    return daysDiff <= 0 ? result : null;
  }

  resetOtherDaysAvailability() {
    this.availabilityText = 'showAvailableDays';
    this.otherAvailableDays = [];
    this.showOtherDays = false;
    this.showRefreshText = false;
    this.selectedDay = '';
    this.dateSelectedInOtherDaysAvailability = '';
  }

  setAvailableMealPeriod(mealPeriods) {
    if (mealPeriods.length > 0) {
      this.reservationConfig.push(
        {
          type: 'radio',
          name: 'mealPeriod',
          placeholder: '',
          options: mealPeriods.map(x => ({ id: x.Id, value: x.Name })),
          isFormArray: false,
          label: 'mealPeriod',
          class: "reservation-details__meal-period",
          value: 0,
          cellClick: this.CheckAvailability.bind(this),
          disabled: false
        }
      )
      this.reservationConfig = [...this.reservationConfig];
      this.availableMealPeriods = mealPeriods;
      this.dfs.selectedRadioOption = null;
    }
  }

  selectedTimeArray(timeBtn) {
    let availableTimeBtn = document.querySelectorAll('[id^="btn"]');
    availableTimeBtn.forEach(btn => {
      let id = Number(btn.id.split('-')[1]);
      if (id == timeBtn.Id) {
        this.renderer.setStyle(btn.getElementsByTagName("button")[0], 'background', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.AvailableButtonBackgroundColor);
        this.renderer.setStyle(btn.getElementsByTagName("button")[0], 'color', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.EarlierLaterHoverBackgroundColor);
      }
      else {
        this.renderer.setStyle(btn.getElementsByTagName("button")[0], 'background', '#E5E5E5');
        this.renderer.setStyle(btn.getElementsByTagName("button")[0], 'color', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.AvailableButtonColor);
      }
    });
    this.reservationDetailsFormGp.controls.reservationTime.setValue(timeBtn.Value);
    this.rs.reservationFormGroup.get('reservationDetailsForm').get('reservationTime').setValue(timeBtn.Value);
    this.rs.reservationFormGroup.get('reservationDetailsForm').get('coverTypes').setValue(this.coverTypeForm.form.value);
  }

  generatePartySize(specialMeal) {
    this.partySizeOptions = [];
    let minPartySize = specialMeal ? specialMeal.MinPartySize : 1;
    let maxPartySize = specialMeal ? specialMeal.MaxPartySize : this.ls.restaurantWidgetSettings$.value.MaxPartySize;
    for (let index = minPartySize; index <= maxPartySize; index++) {
      this.partySizeOptions.push({ id: index, value: index });
    }
    this.reservationConfig[0].options = this.partySizeOptions;
    this.reservationConfigForm.form.controls.partySize.setValue(this.partySizeOptions[0].id,);
    this.reservationDetailsFormGp.controls.partySize.setValue(this.partySizeOptions[0].value);

  }

  setAvailableDate(specialMeal) {
    this.isSpecialMealDisabled = false;
    this.restrictAvailabilityCheck(false);
    if (specialMeal && specialMeal.StartDate && specialMeal.EndDate) {
      if (new Date(specialMeal.StartDate).setHours(0, 0, 0, 0) > new Date(new Date().setDate(new Date().getDate() + this.daysForReservation - 1)).setHours(0, 0, 0, 0)) {
        this.reservationConfig[1].minDate = new Date();
        this.reservationConfig[1].maxDate = new Date();
        this.gs.setMessageState(this.ts.instant('BookingYetToOpenMsg'), 0);
        this.isSpecialMealDisabled = true;
        this.restrictAvailabilityCheck(true);
        return;
      }
      else {

        this.reservationConfig[1].minDate = (new Date() >= new Date(specialMeal.StartDate)) ? new Date() : specialMeal.StartDate;
        if (new Date(specialMeal.StartDate).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
          this.reservationConfigForm.form.controls.reservationDate.setValue(new Date());
          this.reservationDetailsFormGp.controls.reservationDate.setValue(new Date());
        } else {
          this.reservationConfigForm.form.controls.reservationDate.setValue(this.reservationConfig[1].minDate);
          this.reservationDetailsFormGp.controls.reservationDate.setValue(this.reservationConfig[1].minDate);

        }
      }
      if (new Date(specialMeal.EndDate).setHours(0, 0, 0, 0) > new Date(new Date().setDate(new Date().getDate() + this.daysForReservation - 1)).setHours(0, 0, 0, 0)) {
        this.reservationConfig[1].maxDate = new Date(new Date().setDate(new Date().getDate() + this.daysForReservation - 1));
      }
      else {
        this.reservationConfig[1].maxDate = specialMeal.EndDate;
      }
    }
    else {
      let {minDate, maxDate} = this.getMinMaxDate();
      this.reservationConfig[1].minDate = minDate;
      this.reservationConfig[1].maxDate = maxDate;
      if(this.CustomOpenHours?.length == 0 && this.openHourDays?.length == 0)
        this.reservationConfig[1].maxDate = new Date();
      this.reservationConfigForm.form.controls.reservationDate.setValue(this.reservationConfig[1].minDate);
      this.reservationDetailsFormGp.controls.reservationDate.setValue(this.reservationConfig[1].minDate);
    }
    if ((specialMeal?.FrequencyTypeIds && specialMeal?.FrequencyTypeIds != null) || (this.openHourDays && this.openHourDays.length > 0)) {

      if (specialMeal.FrequencyTypeIds != null && this.openHourDays.length > 0) {
        let mergedArray = [];       
        specialMeal.FrequencyTypeIds.every(a => this.openHourDays.includes(a) ? mergedArray.push(a) : '');
        this.reservationConfig[1].FrequencyTypeIds = this.setFrequencyDate(mergedArray);
      }
      else if (specialMeal.FrequencyTypeIds != null && this.openHourDays.length <= 0) {
        this.reservationConfig[1].FrequencyTypeIds = this.setFrequencyDate(specialMeal.FrequencyTypeIds);
      }
      else {
        this.reservationConfig[1].FrequencyTypeIds = this.setFrequencyDate(this.openHourDays);
      }

      this.reservationDetailsFormGp.controls.reservationDate.setValue(this.reservationConfig[1].FrequencyTypeIds);
    } else {
      this.reservationConfig[1].FrequencyTypeIds = this.setFrequencyDate([]);
      this.reservationDetailsFormGp.controls.reservationDate.setValue(this.reservationConfig[1].FrequencyTypeIds);
    }
   this.SetInitialDate(new Date(this.reservationConfig[1].minDate));
  }

  
  getMinMaxDate(): {minDate, maxDate}{
    let minDate = null;
    let maxDate = null;
    if(this.openHourDays?.length){
      minDate = new Date();
      maxDate = new Date(new Date().setDate(new Date().getDate() + this.daysForReservation - 1));
    }
    else if(this.CustomOpenHours?.some(custDay => !custDay.Closed)){
      // this.openHourDays = this.CustomOpenHours.map(customDay => new Date(customDay.Date).getDay());
      this.CustomOpenHours.forEach(customDay => {
        if(!customDay.Closed && (new Date(customDay.Date) > maxDate || !maxDate)){
          maxDate = new Date(customDay.Date);
        }
        if(!customDay.Closed && (new Date(customDay.Date) <= minDate || !minDate)){
          minDate = new Date(customDay.Date);
        }
        // this.openHourDays.push(new Date(customDay.Date).getDay());
      })
    }

    if(minDate <= new Date()){
      minDate = new Date()
    }
    return {minDate, maxDate}
  }

 SetInitialDate(date: Date){
    let IsHoliday = false;
    IsHoliday = this.IsHoliday(date)
    if(IsHoliday) {
     date.setDate(date.getDate() + 1);
     this.SetInitialDate(date);
    }
    else{
      this.reservationConfigForm.form.controls.reservationDate.setValue(date);
      this.reservationDetailsFormGp.controls.reservationDate.setValue(date);
    }
  }

  IsHoliday(date: Date){
    let isHoliday = false; 
    isHoliday =  this.IsCustomDay(date) ? this.IsCustomHoliday(date) : !this.openHourDays.includes(date.getDay());
    return isHoliday;
  }

  setFrequencyDate(days) {
    let frequencyDate = (d: Date): boolean => {
      if (d !== null) {
        const date =  (new Date(d) || new Date());
        const day = date.getDay();
        let enableDate = days.includes(day);
        if (this.CustomOpenHours.length > 0 && this.IsCustomDay(date)) {
          let IsHoliday = this.IsHoliday(date);
          enableDate = !IsHoliday;
        }
        return enableDate;
      } else {
        return false;
      }
    }
    return frequencyDate //days.length !== 0 ? frequencyDate : !(frequencyDate);
  }

  IsCustomDay(date: Date){
    for (let holiday of this.CustomOpenHours) {
      let date1 = moment(holiday.Date).format('LL');
      let date2 = moment(date).format('LL');
      if (date1 == date2) {
        return true;
      };
    }
    return false;
  }

  IsCustomHoliday(date: Date) {
    for (let holiday of this.CustomOpenHours) {
      let date1 = moment(holiday.Date).format('LL');
      let date2 = moment(date).format('LL');
      if (date1 == date2) {
        return holiday.Closed;
      };
    }
    return false;
  }

  selectedSpecialMeal(meal) {
    this.partySizeError = '';
    this.isNextBtnDisabled = false;
    this.addPartySizeConfig();
    if (_.isEqual(this.selectedMeal, meal) && meal && this.dfs.selectedRadioOption == 1) {
      return;
    }
    this.gs.setMessageState('', 0);
    this.availableCoverTypePrices = [];
    this.coverTypeConfig = [];
    this.selectedMeal = meal ? meal : '';
    this.reservationDetailsFormGp.controls.specialMeal.setValue(this.selectedMeal);
    this.rs.reservationFormGroup.get('reservationDetailsForm').get('specialMeal').setValue(this.selectedMeal);
    this.setAvailableSeatings(this.selectedMeal);
    this.generatePartySize(this.selectedMeal);
    this.setAvailableDate(this.selectedMeal);
    if (this.selectedMeal) {
      this.availableCoverTypePrices = this.specialMealList.find(x => x.Id == this.selectedMeal.Id)?.CoverTypePrices ? this.specialMealList.find(x => x.Id == this.selectedMeal.Id)?.CoverTypePrices : [];
      if (this.availableCoverTypePrices.length > 0) {
        this.viewPrice(meal)
      }
      else {
        this.coverTypeConfig = [];
      }
    }
    else {
      this.coverTypeConfig = [];
    }

    if (this.availabilityText == 'refresh') {
      this.showOtherDaysAvailable();
    }
  }
  addPartySizeConfig() {
    this.reservationConfig[0].class = "reservation-details__party-size";
    this.reservationConfig = [...this.reservationConfig];
  }
  showPrepaymentIcon() {
    return (this.specialMealList && this.specialMealList.find(sp => sp.DoesRequirePrepayment));
  }

  selectedViewPricing(meal) {
    if (this.selectedMeal == meal) {
      this.availableCoverTypePrices = [];
      this.availableCoverTypePrices = this.specialMealList.filter(x => x.Id == this.selectedMeal.Id)[0].CoverTypePrices;
    }
    else {
      this.selectedSpecialMeal(meal);
    }
    event.stopPropagation();
  }
  getSeatSelection() {
    //this.LockSlot();
    if (this.dateSelectedInOtherDaysAvailability && moment(moment(this.dateSelectedInOtherDaysAvailability).format('YYYY-MM-DD')).diff(moment(this.reservationDetailsFormGp.controls.reservationDate.value).format('YYYY-MM-DD'), 'days') != 0) {
      this.reservationConfigForm.form.controls.reservationDate.setValue(this.dateSelectedInOtherDaysAvailability, { emitEvent: false });
      this.reservationDetailsFormGp.controls.reservationDate.setValue(this.dateSelectedInOtherDaysAvailability, { emitEvent: false });
    }
    if (this.ls.restaurantWidgetSettings$.value.WidgetCustomization.AllowTableSelection) {
      if (this.ls.operation == operationType.edit && this.reservationDetailsFormGp.controls.reservationTime.value == this.originalReservedFor) {
        this.rs.lockCallRequired = false;
      } else {
        this.rs.lockCallRequired = true;
      }
      this.ls.nextButton.next(componentName.tablesLayout)
    }
    else {
      if (this.ls.operation == operationType.edit && this.reservationDetailsFormGp.controls.reservationTime.value == this.originalReservedFor) {
        this.ls.nextButton.next(componentName.guestDetails);
      }
      else {
        this.LockSlot();
      }
    }
  }

  viewPrice(specialMeal) {

    this.coverTypeConfig = [];
    this.coverTypeConfig = [...this.coverTypeConfig];
    let specialMealValue = this.reservationDetailsFormGp.get('specialMeal').value
    for (let i = this.availableCoverTypePrices.length - 1; i >= 0; i--) {
      this.coverTypeConfig.unshift({
        type: 'input',
        label: this.availableCoverTypePrices[i].CoverTypeName,
        name: this.availableCoverTypePrices[i].Id.toString(),
        inputType: 'number',
        class: 'reservation-details__cover-type',
        showErrorText: true,
        appearance: true,
        isFormArray: false,
        value: i == 0 ? specialMealValue.MinPartySize : 0
      })
    }
    this.coverTypeConfig = [...this.coverTypeConfig];
    this.coverTypeConfig.forEach((x, index) => {
      if (Object.keys(this.coverTypeForm.form.controls).length != 0) {
        if (index == 0) {
          this.coverTypeForm.form.controls[x.name].setValue(this.reservationDetailsFormGp.controls.partySize.value);
        }
        else if (this.coverTypeForm.form.controls[x.name]) {
          this.coverTypeForm.form.controls[x.name].setValue(0);
        }
      }
    });
    this.checkPartySizeValidationAndAssignFormValue();
    this.reservationConfig[0].class = "reservation-details__party-size-noshow"
    this.reservationConfig = [...this.reservationConfig];
  }


  valueIncrease(data, event) {
    let selectedCoverType = this.availableCoverTypePrices.filter(x => x.Id == data)[0];
    let selectedConfig = this.coverTypeForm.form.controls[selectedCoverType.Id.toString()]
    selectedConfig.setValue(selectedConfig.value == this.reservationConfigForm.form.controls.partySize.value ? this.reservationConfigForm.form.controls.partySize.value : (selectedConfig.value + 1));
    selectedConfig.setValue(selectedConfig.value + 1);
    let partySize = 0;
    this.availableCoverTypePrices.forEach(x => {
      partySize += this.coverTypeForm.form.controls[x.Id.toString()].value
    });
    this.reservationConfigForm.form.controls.partySize.setValue(partySize, { emitEvent: false });
    this.reservationDetailsFormGp.controls.partySize.setValue(partySize, { emitEvent: false });

    this.checkPartySizeValidationAndAssignFormValue();

    if (this.ls.operation == operationType.edit && this.ls.editPartyData$.value && this.triggerAvailableDatesApiCall && !this.CheckAvailabilityBtn.disbaledproperity) {
      this.getRestaurantAvailableDates(this.rs.reservationFormGroup.controls.reservationDetailsForm.value.partySize,
        moment(this.rs.reservationFormGroup.controls.reservationDetailsForm.value.reservationDate).format('YYYY-MM-DD'),
        this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id,
        this.rs.reservationFormGroup.controls.reservationDetailsForm.value.specialMeal.Id,
        this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id)
    }
  }


  valueDecrease(data, event) {
    let selectedCoverType = this.availableCoverTypePrices.filter(x => x.Id == data)[0];
    let selectedConfig = this.coverTypeForm.form.controls[selectedCoverType.Id.toString()]
    selectedConfig.setValue(selectedConfig.value == 0 ? 0 : (selectedConfig.value - 1));
    let partySize = 0;
    this.availableCoverTypePrices.forEach(x => {
      partySize += this.coverTypeForm.form.controls[x.Id.toString()].value
    });
    this.reservationConfigForm.form.controls.partySize.setValue(partySize, { emitEvent: false });
    this.reservationDetailsFormGp.controls.partySize.setValue(partySize, { emitEvent: false });
    this.checkPartySizeValidationAndAssignFormValue();

    if (this.ls.operation == operationType.edit && this.ls.editPartyData$.value && this.triggerAvailableDatesApiCall && !this.CheckAvailabilityBtn.disbaledproperity) {
      this.getRestaurantAvailableDates(this.rs.reservationFormGroup.controls.reservationDetailsForm.value.partySize,
        moment(this.rs.reservationFormGroup.controls.reservationDetailsForm.value.reservationDate).format('YYYY-MM-DD'),
        this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id,
        this.rs.reservationFormGroup.controls.reservationDetailsForm.value.specialMeal.Id,
        this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id)
    }
  }

  checkPartySizeValidationAndAssignFormValue() {
    let total = 0;
    this.availableCoverTypePrices.forEach(element => {
      if (this.coverTypeForm.form.controls[element.Id.toString()]) {
        total = total + +this.coverTypeForm.form.controls[element.Id.toString()].value;
      }
      else {
        if (this.coverTypeConfig && this.coverTypeConfig.length > 0)
          total = total + +this.coverTypeConfig.find(x => x.name == element.Id.toString()).value;
      }
    });

    if (this.coverTypeConfig.length) {
      let specialMealPartySize = this.reservationDetailsFormGp.get('specialMeal').value;
      this.coverTypeConfig.forEach(x => {

        // x.increaseDisabled = +total == specialMealPartySize.MaxPartySize  ? true : false;
        // x.decreaseDisabled = +total == specialMealPartySize.MinPartySize ? true : false;
        // x.increaseDisabled = false;
        this.restrictAvailabilityCheck(this.isNextBtnDisabled);
      })
      this.CheckAvailabilityBtn.disbaledproperity = (+total < specialMealPartySize.MinPartySize) || (+total > specialMealPartySize.MaxPartySize);
    }
    if (!(+total == this.reservationConfigForm.form.controls.partySize.value)) {
      this.showSlots = false;
      this.clearMealTabSelection();
    }
    if (this.coverTypeForm && this.coverTypeForm.form) {
      this.reservationDetailsFormGp.controls.coverTypes.setValue(this.coverTypeForm.form.value);
      this.rs.reservationFormGroup.get('reservationDetailsForm').get('coverTypes').setValue(this.coverTypeForm.form.value);
    }
  }

  clearMealTabSelection() {
    if (this.selectedMealTab && this.reservationConfigForm.form.controls.mealPeriod.value == this.selectedMealTab && !this.showOtherDays) { // reset the meal tab radio button
      this.dfs.selectedRadioOption = null;
      this.selectedMealTab = null;
      this.reservationConfigForm.form.controls.mealPeriod.setValue('', { emitEvent: false });
    }
  }

  setAvailableSeatings(specialMeal: any) {
    if (specialMeal && specialMeal.SeatingAreaId && specialMeal.SeatingAreaId > 0) {
      this.reservationConfig[2].options = this.seatingAreaMasterList.filter(x => x.Id == specialMeal.SeatingAreaId).map(x => { return { id: x.Id, value: x.Name } });
    } else {
      this.reservationConfig[2].options = this.seatingAreaMasterList.map(x => { return { id: x.Id, value: x.Name } });
      //this.reservationConfig[2].options.splice(0,0,{ id: 0, value: this.ts.instant('AnySeatingArea')});
    }
    this.reservationConfigForm.form.controls.seatingArea.setValue(this.reservationConfig[2].options[0].id);
    this.reservationDetailsFormGp.controls.seatingArea.setValue({ id: this.reservationConfig[2].options[0].id, name: this.reservationConfig[2].options[0].value });
    this.LoadSeatingTypes(this.reservationConfig[2].options[0].id);
  }

  LoadSeatingTypes(seatingAreaId: number) {
    let MappedSeatingTypes = [];
    MappedSeatingTypes = this.SeatingAreaSeatingTypeMappings.filter(t => t.SeatingAreaId == seatingAreaId || seatingAreaId == 0).map(x => { return x.SeatingTypeId });
    this.reservationConfig[3].options = MappedSeatingTypes.length > 0 ? this.seatingTypesMasterList.filter(x => MappedSeatingTypes.indexOf(x.Id) > -1 || x.Id == 0).map(x => { return { id: x.Id, value: x.Description } }) : [{ id: 0, value: this.ts.instant('AnySeatingType')}];
    //this.reservationConfig[3].options.splice(0,0,{ id: 0, value: this.ts.instant('AnySeatingType)});
    if (this.reservationConfig[3].options.length > 0) {
      this.reservationConfigForm.form.controls.seatingType.setValue(this.reservationConfig[3].options[0].id);
      this.reservationDetailsFormGp.controls.seatingType.setValue({ id: this.reservationConfig[3].options[0].id, name: this.reservationConfig[3].options[0].value });
    }
    else {
      //hide the seatingType Control
    }
  }

  addAnySeatingOptionInMasterList() {

    (this.ls.globalSeatingAreaId || this.seatingAreaMasterList.findIndex(area => area.Id == 0) > -1) || this.seatingAreaMasterList.splice(0, 0, { Id: 0, Name: this.ts.instant('AnySeatingArea')});
    (this.seatingTypesMasterList.findIndex(type => type.Id == 0) > -1) || this.seatingTypesMasterList.splice(0, 0, { Id: 0, Description: this.ts.instant('AnySeatingType')});
  }

  removeSeatingAreaWhichHasNoSeatingTypeMappings() {
    this.seatingAreaMasterList = this.seatingAreaMasterList.filter(x => this.SeatingAreaSeatingTypeMappings.findIndex(y => y.SeatingAreaId == x.Id))
  }

  CheckAvailability(event) {
    this.selectedMealTab = event.value;
    this.getRestaurantDateAvailability();
  }

  getRestaurantAvailableDates(size, date, seatingArea, sepcialMeal, seatingType) {
    seatingType = this.displaySeatingType ? seatingType : null;
    this.restrictAvailabilityCheck(false);
    this.rs.GetRestaurantAvailableDates(this.ls.restaurantWidgetSettings$.value.RestaurantId,
      size, date, seatingArea > 0 ? seatingArea : null, this.ls.editPartyData$.value.Id, sepcialMeal, seatingType > 0 ? seatingType : null).subscribe(dates => {
        this.triggerAvailableDatesApiCall = true;
        if (dates && dates.length > 0) {
          this.reservationConfig[1].minDate = new Date(dates[0]);
          this.reservationConfig[1].maxDate = new Date(dates[dates.length - 1]);
        }
        else {
          this.gs.setMessageState(this.ts.instant('cannotAccommodateParty'), 0); // assign the Error Message
          this.restrictAvailabilityCheck(true);
        }
      })
  }


  getRestaurantDateAvailability(otherDate?: any) {
    this.showSlots = true;
    let Date = moment(this.rs.reservationFormGroup.controls.reservationDetailsForm.value.reservationDate).format('YYYY-MM-DD');
    let _selectedDate = otherDate ? otherDate : Date;
    let isCommunalTable = this.rs.reservationFormGroup.controls.reservationDetailsForm.value.communalAvailability || this.ls.editPartyData$.value?.IsCommunalTable;
    this.subscriptions.add(this.rs.GetRestaurantDateAvailability(
      this.restaurantId,
      this.rs.reservationFormGroup.controls.reservationDetailsForm.value.partySize,
      isCommunalTable,
      true,
      _selectedDate,
      this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id > 0 ? this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id : null,
      this.ls.operation == operationType.edit ? this.ls.editPartyData$.value.Id : null,
      this.rs.reservationFormGroup.controls.reservationDetailsForm.value.specialMeal.Id,
      this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id > 0 && this.displaySeatingType ? this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id : null
    ).subscribe(data => {
      this.timeBtnArray = [];
      if (data && data.length > 0) {
        data.forEach((time, index) => {
          this.timeBtnArray.push({ Id: index, Value: time })
        });
        if (this.availableMealPeriods.length > 0) {
          let selectedMealTab: MealTabDTO;
          this.spliceTimeArrayForTheSelectedMealTab(_selectedDate);
        }
        if (this.originalReservedFor) {
          const selectedSlot = this.timeBtnArray.filter(slot => slot.Value == this.originalReservedFor);
          if (selectedSlot.length) {
            setTimeout(() => {
              this.selectedTimeArray(selectedSlot[0]);
            })
          }
        }
        if (this.ls.restaurantWidgetSettings$.value.WidgetCustomization.TimeSlotType == "DropDown") {
          this.isDropdown = true;
          let timeArrayValues = this.timeBtnArray.map(time => {
            return { id: time.Id, value: time.Value }
          })
          this.timeBtnArrayConfig = [
            {
              type: 'select',
              name: 'time',
              placeholder: '',
              options: timeArrayValues,
              appearance: true,
              isFormArray: false,
              label: 'time',
              class: "reservation-details__party-size",
              validation: [Validators.required],
              isNativeControl: this.ls.isMobileBrowser,
              isDateTime: true,
              cellClick: this.selectedDateTime.bind(this)
            }
          ]
        } else {
          this.isDropdown = false;
        }
      }
      else {
        //Show No Slots Available
      }
      setTimeout(() => {
        this.scrollBottom();
      }, 100);
    }));
  }
  selectedDateTime(event) {
    let selectedSlotVal = event.value;
    if (this.ls.isMobileBrowser) {
      selectedSlotVal = event.target.value;
    }
   let selectedSlot = this.timeBtnArrayConfig[0].options.find(data => data.id == selectedSlotVal);
    if (selectedSlot) {
      this.reservationDetailsFormGp.controls.reservationTime.setValue(selectedSlot.value);
      this.rs.reservationFormGroup.get('reservationDetailsForm').get('reservationTime').setValue(selectedSlot.value);
      this.rs.reservationFormGroup.get('reservationDetailsForm').get('coverTypes').setValue(this.coverTypeForm.form.value);
    }
  }
  LockSlot() {
    let lockSlotDto = {
      LocalTime: moment(this.rs.reservationFormGroup.controls.reservationDetailsForm.value.reservationTime).format('YYYY-MM-DDTHH:mm:ss'),  //selected date and time
      PartySize: this.rs.reservationFormGroup.controls.reservationDetailsForm.value.partySize,
      SeatingAreaId: this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id > 0 ? this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id : null,
      SeatingTypeId: this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id > 0 ? this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id : null,
      IsCommunalTable: this.rs.reservationFormGroup.controls.reservationDetailsForm.value.communalAvailability,
      FromWebsite: true
    }
    this.subscriptions.add(this.rs.GetLockSlot(this.ls.restaurantWidgetSettings$.value.RestaurantId, lockSlotDto).subscribe(data => {
      if (data && data.SlotLockIdDTO) {
        //configure Timer
        this.gs.setMessageState('', 0);
        this.ls.lockResult = data;
        let timer = moment(data.ExpiresAt).diff(moment(data.LockedAt), "seconds");
        this.ls.showTimer = true;
        this.ls.runTimer(timer);

        if (this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id == 0 && data.SeatingAreaId > 0) { //slot seating Area Id Locked
          let control = this.rs.reservationFormGroup.get('reservationDetailsForm');
          control.get('seatingArea').setValue({ id: data.SeatingAreaId, name: this.seatingAreaMasterList.filter(x => x.Id == data.SeatingAreaId)[0].Name }, { emitEvent: false });
        }

        data.TableLockedDTO ? this.showSeatingPriceIfRequired(data.TableLockedDTO) : this.ls.nextButton.next(componentName.guestDetails);
      }
      else {
        this.gs.setMessageState(this.ts.instant('SlotIsNotFound'), 0);
      }

    }));
  }

  showSeatingPriceIfRequired(tableLockDTO: TableLockedDTO) {
    if (tableLockDTO && tableLockDTO.TableIds && tableLockDTO.TableIds.length > 0) {
      this.tableLockDTO = _.cloneDeep(tableLockDTO);
      if (tableLockDTO.Price > 0) {
        this.showRatePlanInformationPopUp(this.seatingTypesMasterList.filter(x => x.Id == tableLockDTO.SeatingTypeId)[0].Description, tableLockDTO.Price);
        return;
      }
      else {
        this.updateLockedTableInReservationForm(tableLockDTO);
      }
    }
    else {
      let control = this.rs.reservationFormGroup.get('reservationDetailsForm');
      control.get('tableId').setValue([], { emitEvent: false });
    }
    this.ls.nextButton.next(componentName.guestDetails);
  }

  updateLockedTableInReservationForm(tableLockDTO) {

    let control = this.rs.reservationFormGroup.get('reservationDetailsForm');
    control.get('tableId').setValue(tableLockDTO.TableIds, { emitEvent: false });

    // if (this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id != tableLockDTO.SeatingAreaId) {
    //   control = this.rs.reservationFormGroup.get('reservationDetailsForm');
    //   control.get('seatingArea').setValue({ id: tableLockDTO.SeatingAreaId, name: this.seatingAreaMasterList.filter(x => x.Id == tableLockDTO.SeatingAreaId)[0].Name }, { emitEvent: false });
    // }

    if (this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id != tableLockDTO.SeatingTypeId && tableLockDTO.SeatingTypeId > 0) {
      control = this.rs.reservationFormGroup.get('reservationDetailsForm');
      control.get('seatingType').setValue({ id: tableLockDTO.SeatingTypeId, name: this.seatingTypesMasterList.filter(x => x.Id == tableLockDTO.SeatingTypeId)[0].Description }, { emitEvent: false });
    }
  }

  showRatePlanInformationPopUp(seatingTypeName: string, amount: Number) {
    const popUpMessage = [{
      confirmationMessage: this.getRatePlanText(seatingTypeName, amount),
      dialogTitle: this.ts.instant('seatingTypePriceInfo'),
      showAlert: true
    }];
    const componentDetails: ComponentDetails = Utilities.setComponentDetails(PopupMessageComponent, 'small', '', popUpMessage,
      popUpMessage[0].dialogTitle);
    this.seatingTypeInfoPopup = this.openCustomPopup(componentDetails, ComponentTypes.seatingTypeInfoPopup, '450px', '300px', true, '', this.ts.instant('Yes'),
      this.ts.instant('No'), true)
  }

  getRatePlanText(seatingTypeName: string, amount: Number){
    let message : string = "";
    this.ts.get('seatingTypeReservedAndConfirmation', {seatingTypeName: seatingTypeName, amount: (this.ls.restaurantWidgetSettings$.value.OperationCurrency + amount.toFixed(this.ls.restaurantWidgetSettings$.value.NumberOfFractionalDigits))}).subscribe(result => { message = result; });
    return message;
  }

  spliceTimeArrayForTheSelectedMealTab(date) {
    let requiredTimeArray = [];
    let selectedMealTab = this.availableMealPeriods.filter(meal => meal.Id == this.selectedMealTab)[0];
    if (selectedMealTab) {
      let startHours = selectedMealTab.StartTime.split(':')[0];
      let startMins = selectedMealTab.StartTime.split(':')[1];
      let endHours = selectedMealTab.EndTime.split(':')[0];
      let endMins = selectedMealTab.EndTime.split(':')[1];
      let selectedDate = moment(date).format('YYYY-MM-DD');
      let startTime = moment(selectedDate).clone().add(startHours, 'hours').add(startMins, 'minutes').format("YYYY-MM-DDTHH:mm:ss");
      let endTime = moment(selectedDate).clone().add(endHours, 'hours').add(endMins, 'minutes').format("YYYY-MM-DDTHH:mm:ss");
      if (moment(startTime) > moment(endTime)) {
        endTime = moment(endTime).add(1, 'day').format("YYYY-MM-DDTHH:mm:ss");
      }
      if (this.timeBtnArray.length > 0) {
        this.timeBtnArray.forEach(time => {
          if (Utilities.datetimeBetween(new Date(startTime), new Date(endTime), new Date(time.Value))) {
            requiredTimeArray.push(time);
          }
        })
      }
      this.timeBtnArray = requiredTimeArray;
    }
  }

  restrictAvailabilityCheck(check: boolean) {
    if (this.availableMealPeriods.length > 0 && this.reservationConfigForm.form.controls.mealPeriod) {
      this.reservationConfig.find(x => x.name == "mealPeriod").disabled = check || this.isSpecialMealDisabled;
      check || this.isSpecialMealDisabled ? this.reservationConfigForm.form.controls["mealPeriod"].disable({ emitEvent: false }) : this.reservationConfigForm.form.controls["mealPeriod"].enable({ emitEvent: false });
    }
    else if (this.availableMealPeriods.length > 0) {
      this.reservationConfig.find(x => x.name == "mealPeriod").disabled = check || this.isSpecialMealDisabled;
    }
    this.CheckAvailabilityBtn.disbaledproperity = this.isSpecialMealDisabled;
    if (!check && this.availableMealPeriods.length == 0) {
      this.resetOtherDaysAvailability();
    }
  }

  onRefreshClick() {
    window.location.reload();
  }

  scrollBottom() {
    let id = !this.isDropdown ? 'timeBtnGroup' : 'timeDropDownGroup'; 
    let element = document.getElementById(id);
    if(element) {
      element.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
      element = null;
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}


@Pipe({
  name: 'seatingTypeFilter'
})
export class SeatingTypeFilter implements PipeTransform {

  transform(typeId: any, seatingTypesList: any): any {
    return (seatingTypesList.filter(x => x.Id == typeId)[0].Description);
  }

}
